import { CommandProps, JSONContent, Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { BlockTypes, QuoteBlockData } from '../../../../models';
import { QuoteNodeView } from './QuoteNodeView';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    quoteNode: { insertQuoteNode: ({ text, caption, alignment }: QuoteBlockData) => ReturnType };
  }
}

const getPlainText = (nodes: JSONContent[]): string => {
  const isInlineContent = nodes.every(({ type }) => type === 'text' || type === 'hardBreak');

  return nodes
    .map(({ type, text, content = [] }) => {
      if (type === 'hardBreak') {
        return '\n';
      }

      return text ?? getPlainText(content);
    })
    .join(isInlineContent ? '' : '\n');
};

export const QuoteNode = Node.create({
  name: 'quoteNode',
  group: 'block',
  atom: true,
  markdownTokenName: 'blockquote',

  addAttributes() {
    return { text: '', caption: '', alignment: '' };
  },

  parseHTML() {
    return [{ tag: BlockTypes.quote }];
  },

  renderHTML({ HTMLAttributes }) {
    return [BlockTypes.quote, mergeAttributes(HTMLAttributes)];
  },

  parseMarkdown(token, helpers) {
    return helpers.createNode(this.name, {
      text: getPlainText(helpers.parseChildren(token.tokens ?? [])),
      caption: '',
      alignment: 'left',
    });
  },

  addCommands() {
    return {
      insertQuoteNode:
        ({ text, caption, alignment }: QuoteBlockData) =>
        ({ commands }: CommandProps) => {
          return commands.insertContent({ type: this.name, attrs: { text, caption, alignment } });
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(QuoteNodeView);
  },
});
